import { AppointmentStatus, JobType } from '../../interfaces/appointments';

// From this many non-hotel bookings on a day, the count is shown in red.
export const BOOKING_COUNT_WARNING_THRESHOLD = 8;

type CountableBooking = {
  date: string;
  status: AppointmentStatus;
  jobType?: string | null;
};

// Bookings that are not of type Hotell on the given day. Cancelled and rejected bookings don't count.
export const countNonHotelBookings = (bookings: CountableBooking[], dateIso: string): number =>
  bookings.filter(
    (booking) =>
      booking.date === dateIso &&
      booking.status !== AppointmentStatus.CancelledByAdmin &&
      booking.status !== AppointmentStatus.Rejected &&
      booking.jobType !== JobType.TireHotel,
  ).length;

export const bookingCountColor = (count: number): string | undefined =>
  count >= BOOKING_COUNT_WARNING_THRESHOLD ? 'error.main' : undefined;
